import { useInView } from 'react-intersection-observer';
import teacher1 from '../../../assets/images/teacher_1.jpg';
import teacher2 from '../../../assets/images/teacher_2.jpg';
import teacher3 from '../../../assets/images/teacher_3.jpg';

const PHOTOS = [
  { src: teacher2, alt: '아나톨레 어학원 강사진' },
  { src: teacher1, alt: '수업을 준비하는 아나톨레 강사진' },
  { src: teacher3, alt: '행사를 함께 즐기는 아나톨레 강사진' },
];

export default function TeacherSection() {
  const { ref, inView } = useInView({ threshold: 0.2, triggerOnce: true });

  return (
    <section
      ref={ref}
      className="px-[16px] tablet:px-[35px] desktop:py-[100px] py-[50px] bg-alternate"
    >
      <div className="max-w-[1480px] mx-auto">
        <div className={`${inView ? 'animate-fadeSlideUp' : ''}`}>
          <h2 className="font-inter font-semibold text-headline-medium desktop:text-display-medium">
            <span className="text-primary">Meet our</span> <span className="text-secondary">Teachers</span>
          </h2>
          <p className="kr-font mt-[16px] desktop:mt-[28px] text-secondary-text text-body-large desktop:text-headline-small leading-relaxed desktop:leading-[44px] break-keep">
            아이들의 영어 학습 여정을 함께 이끌어 가는
            <br className="hidden tablet:block" />
            {' '}경험 많고 실력있는 전문 강사진입니다.
          </p>
        </div>

        <div className="mt-[32px] desktop:mt-[60px] grid grid-cols-1 tablet:grid-cols-3 gap-[16px] desktop:gap-[24px]">
          {PHOTOS.map((photo, i) => (
            <div
              key={photo.src}
              className={`overflow-hidden rounded-[24px] desktop:rounded-[32px] shadow-lg bg-primary-background ${
                inView ? 'animate-fadeSlideUp' : ''
              }`}
              style={{ animationDelay: `${i * 140}ms` }}
            >
              <img
                src={photo.src}
                alt={photo.alt}
                loading="lazy"
                className="w-full h-[240px] tablet:h-[260px] desktop:h-[320px] object-cover"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
